<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">Merchant Users</h4>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-icon-text text-white float-right" @click="showCreateUserModal">
              <span class="h4 text-white">New User </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="user-listing" class="table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>Developer</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.uuid">
            <td>{{ user.fullName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.mobileNumber }}</td>
            <td>
              <span :class="user.isDeveloper ? 'badge badge-success' : 'badge badge-info'">
                {{ user.isDeveloper ? 'Yes' : 'No' }}
              </span>
            </td>
            <td>
              <button class="btn btn-outline-danger ml-2" @click="deleteUser(user.uuid)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Create User Modal -->
    <div class="modal fade" id="createUserModal" tabindex="-1" role="dialog" aria-labelledby="createUserModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createUserModalLabel">Create New User</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="createUser">
              <div class="form-group" v-if="msg != ''">
                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                  <strong>{{ msg }}</strong>
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="form-group">
                <label>Full Name</label>
                <input type="text" class="form-control" v-model="userData.fullName" required />
              </div>

              <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" v-model="userData.email" required />
              </div>

              <div class="form-group">
                <label>Mobile Number</label>
                <input type="tel" class="form-control" v-model="userData.mobileNumber" required />
              </div>

              <div class="form-group">
                <label>Password</label>
                <input type="password" class="form-control" v-model="userData.password" required />
              </div>

              <div class="form-group">
                <label>Confirm Password</label>
                <input type="password" class="form-control" v-model="userData.confirmPassword" required />
              </div>

              <div class="form-group">
                <div class="form-check form-check-flat form-check-primary">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="userData.isDeveloper" />
                    Is Developer Account
                    <i class="input-helper"></i>
                  </label>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Create User</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "MerchantUsers",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      msg: "",
      users: [],
      userData: {
        fullName: "",
        email: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        isDeveloper: false
      }
    };
  },
  methods: {
    showCreateUserModal() {
      this.resetForm();
      jQuery("#createUserModal").modal("show");
    },
    resetForm() {
      this.msg = "";
      this.userData = {
        fullName: "",
        email: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        isDeveloper: false
      };
    },
    async getUsers() {
      try {
        const response = await api.doGet(`/api/merchant/${this.$route.params.merchantUuid}/users`);
        if (response.status === "00") {
          this.users = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch users");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        this.toast.error("An error occurred while fetching users");
      }
    },
    async createUser() {
      if (this.validateFields()) {
        try {
          const payload = {
            ...this.userData,
            merchantUuid: this.$route.params.merchantUuid
          };
          delete payload.confirmPassword; // Remove confirmPassword from payload

          const response = await api.doPost('/api/merchant/user/create', payload);
          
          if (response.status === "00") {
            this.toast.success(response.message);
            jQuery("#createUserModal").modal("hide");
            this.getUsers();
          } else {
            this.msg = response.message || "Failed to create user";
          }
        } catch (error) {
          console.error("Error creating user:", error);
          this.msg = "An error occurred while creating the user";
        }
      }
    },
    validateFields() {
      if (
        this.userData.fullName === "" ||
        this.userData.email === "" ||
        this.userData.mobileNumber === "" ||
        this.userData.password === "" ||
        this.userData.confirmPassword === ""
      ) {
        this.msg = "Please complete all required fields";
        return false;
      }

      if (this.userData.password !== this.userData.confirmPassword) {
        this.msg = "Passwords do not match";
        return false;
      }

      return true;
    },
    async deleteUser(uuid) {
      if (confirm("Are you sure you want to delete this user?")) {
        try {
          const response = await api.doPost('/merchant/user/delete', { uuid });
          
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getUsers();
          } else {
            this.toast.error(response.message || "Failed to delete user");
          }
        } catch (error) {
          console.error("Error deleting user:", error);
          this.toast.error("An error occurred while deleting the user");
        }
      }
    }
  },
  mounted() {
    this.getUsers();
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style> 